import { Suspense, type ReactNode } from "react";
import { Spinner } from "@/components/ui";

/** Suspense boundary with a centered glow spinner for lazy routes. */
export function Lazy({ children }: { children: ReactNode }) {
  return (
    <Suspense
      fallback={
        <div className="grid min-h-[50dvh] place-items-center">
          <Spinner className="size-8 text-cyan" />
        </div>
      }
    >
      {children}
    </Suspense>
  );
}
